import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";

@Injectable({ providedIn: "root" })
export class EmptystateStyle extends BaseStyle {
  override name = "emptystate";

  override theme = ({ dt }: any): string => `
    .ui-emptystate {
      display: flex;
      flex-direction: column;
      gap: ${dt("emptystate.gap")};
      text-align: center;
      align-items: center;
    }

    .ui-emptystate-image {
      max-width: ${dt("emptystate.image.size")};
      max-height: ${dt("emptystate.image.size")};
    }

    .ui-emptystate-text {
      display: flex;
      flex-direction: column;
      gap: ${dt("emptystate.text.gap")};
    }

    .ui-emptystate-caption {
      font-size: ${dt("emptystate.caption.font.size")};
      font-weight: ${dt("emptystate.caption.font.weight")};
      line-height: ${dt("emptystate.caption.font.leading")};
    }

    .ui-emptystate-description {
      color: ${dt("emptystate.description.color")};
      white-space: pre-line;
    }
  `;

  override classes = {
    root: "ui-emptystate",
    image: "ui-emptystate-image",
    text: "ui-emptystate-text",
    caption: "ui-emptystate-caption",
    description: "ui-emptystate-description",
  };
}
